export function getUserInitials(name?: string, surname?: string) {
  const firstInitial = name?.charAt(0)?.toUpperCase() ?? '';
  const lastInitial = surname?.charAt(0)?.toUpperCase() ?? '';

  if (firstInitial && lastInitial) {
    return `${firstInitial}${lastInitial}`;
  }

  return firstInitial;
}
